module.exports = __webpack_public_path__ + "static/img/ldt1.9fc4cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/ldt1.png
// module id = TTow
// module chunks = 0